/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createServicesRepository = (options: RestApiOptions): Types.ServicesRepository => ({
    async getAvailability(params, requestOptions) {
        return options.request('/services/getAvailability', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getCalendarData(params, requestOptions) {
        return options.request('/services/getCalendarData', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getPricing(params, requestOptions) {
        return options.request('/services/getPricing', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getPromotions(params, requestOptions) {
        return options.request('/services/getPromotions', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
